<template>
    <span :class="'rounded p-2 py-1' + ' ' + colors[providerLevelTitle]">
        {{ providerLevelTitle }}
    </span>
</template>
<script>
export default {
    name: "ProviderLevelLabel",
    props: {
        providerLevelTitle: {
            type: String,
            default: "--",
        },
    },
    data() {
        return {
            colors: {
                EMR: "bg-green-250 text-green-800",
                EMT: "bg-blue-200 text-blue-800",
                AEMT: "bg-purple-100 text-purple-200",
                Paramedic: "bg-red-150 text-red-800",
                "--": "bg-gray-200 text-gray-400",
            },
        };
    },
};
</script>
